import React from "react";
import { Link } from "react-router-dom";
import { useCookie } from "../../contexts/CookieContext";

const linkClass = "text-slate-400 hover:text-white transition-colors text-sm";

export const LandingFooter = () => {
  const { openSettings } = useCookie();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            {/* <div className="flex items-center mb-5">
              <img src="/img/logo.png" alt="AmpTrans logo" className="h-14 w-14 object-contain" />
            </div> */}
            <p className="text-slate-400 text-sm leading-relaxed">
              Analytics and strategic solutions to make every mile smarter.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/#about" className={linkClass}>About Us</Link></li>
              <li><Link to="/#solutions" className={linkClass}>Solutions</Link></li>
              <li><Link to="/contact" className={linkClass}>Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Solutions</h4>
            <ul className="space-y-3">
              <li><Link to="/solutions/fleet" className={linkClass}>Fleet Owners</Link></li>
              <li><Link to="/solutions/charging" className={linkClass}>Charging Stations</Link></li>
              <li><Link to="/utilities" className={linkClass}>Utilities</Link></li>
              <li><Link to="/solutions/regulator" className={linkClass}>Regulators</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/contact" className={linkClass}>Contact Sales</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy-policy" className={linkClass}>Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className={linkClass}>Terms of Service</Link></li>
              <li>
                <button type="button" onClick={openSettings} className={linkClass + " text-left"}>
                  Cookie Policy
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">© {new Date().getFullYear()} AmpTrans. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="text-slate-500 hover:text-white transition-colors text-sm">Privacy</Link>
            <Link to="/terms-and-conditions" className="text-slate-500 hover:text-white transition-colors text-sm">Terms</Link>
            <button type="button" onClick={openSettings} className="text-slate-500 hover:text-white transition-colors text-sm">
              Cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
